import { render } from "./workflowchart-item.vue?vue&type=template&id=5dc21d46"
import script from "./workflowchart-item.vue?vue&type=script&lang=js"
export * from "./workflowchart-item.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__